import api from '@anm/api';
import { SECOND_MS } from '@anm/constants/date';
import formatDate from '@anm/helpers/date/formatDate';
import getIsPastStream from '@anm/helpers/stream/getIsPastStream';
import { LiveStreamKind, LiveStreamMeta, LiveStreamStatus } from 'types/stream';

import config from '../../../config';

const { urls } = config();

type DateProps = {
  added: string;
  kind: LiveStreamKind;
  schedule: string | null;
  state: LiveStreamStatus;
  startedAt?: string;
};

export const getStreamDates = ({ added, schedule, state, kind, startedAt }: DateProps) => {
  const hasNoDate = (kind === 'RECORD' || (kind === 'LIVE' && !schedule)) && state === 'SCHEDULED';

  const createDate = formatDate(added, { isReplaceValue: false, showYear: true, hoursSuffix: ' ' });

  if (hasNoDate) {
    return [, createDate] as const;
  }

  const isInLive = state === 'INPROGRESS';
  const isScheduled = state === 'SCHEDULED' && schedule;
  const isPastStream = getIsPastStream(state);

  const date = isScheduled ? schedule : startedAt;
  const itemDate = date ? formatDate(date, { isReplaceValue: false }) : undefined;

  const pastStreamDatePrefix =
    kind === 'RECORD' ? 'Recorded' : kind === 'LIVE' ? 'Streamed live' : 'Streamed recording';

  const itemStringDate = isPastStream
    ? `${pastStreamDatePrefix}<br>${itemDate}`
    : isInLive
    ? `Started at${itemDate?.split('at')[1]}`
    : isScheduled
    ? `Scheduled on<br>${itemDate}`
    : itemDate;

  return [itemStringDate, createDate] as const;
};

export const getDuration = (meta: LiveStreamMeta, state: LiveStreamStatus) => {
  const infoDuration = meta.info?.duration;
  const lastStartedAt = meta.paused?.lastStartedAt || 0;
  const pausedDuration = meta.paused?.stats.duration || 0;

  switch (true) {
    case !meta?.startedAt:
      return 0;
    case getIsPastStream(state):
      return infoDuration || meta.duration;
    case !meta?.paused:
      return (new Date(meta?.endedAt || 0).getTime() - new Date(meta?.startedAt || 0).getTime()) / SECOND_MS;
    case !!lastStartedAt && !!pausedDuration:
      return (
        (new Date(meta.endedAt || 0).getTime() - new Date(lastStartedAt).getTime()) / SECOND_MS +
        (infoDuration ? pausedDuration : 0)
      );
    default:
      return 0;
  }
};

export const createProjectFromRecordings = (streamId?: string) => {
  const url = `${urls.editor}#new=${streamId}&type=live-stream-id`;
  window.open(url, '_self');
};

export const openRecordingFolder = async (folderId: string) => {
  const { path } = await api().uploads.getUploadFolderPath(folderId);
  window.open(`${urls.wave}uploads/${encodeURIComponent(path.slice(1))}`, '_self');
};

export const getProjectLink = (id: string) => `${urls.wave}video/${id}`;
